module.exports = __webpack_public_path__ + "static/media/file_ex.3e0179ae.png";